import { ANGRY_GHOST, SATISFIED_GHOST } from '../../TwoD/Common/CardUtilities';

export default function artificialPlaceGhost(gamePlayerController, aiPackage) {
    // CC_AI_PLACE_GHOST_COUNT_DECLINE: attacking_ghosts is a SCALAR count
    // (GameDefaults seeds it to 0; the backend logs it as a number), NOT an
    // array — the old `.length === 0` guard was permanently dead and let a
    // zero-count re-fire fall through to a phantom placeGhost. When there is
    // nothing to place (count 0, or defensively null/undefined) the route
    // must close the always-act branch with an explicit clickNext() decline,
    // mirroring the `else … clickNext()` shape in AIGhostAction's
    // attackTarget / aiRemoveGhost.
    let attackingGhosts = gamePlayerController.gamePlayerData.attacking_ghosts;
    if (!attackingGhosts) {
        aiPackage.success = true;
        aiPackage.complete = true;
        aiPackage.addToMessage(`No Ghosts to place.`);
        if (aiPackage.execute) {
            gamePlayerController.gamePlayerApi.clickNext();
        }
        return aiPackage;
    }

    let dockWeights = [0, 2, 2, 2];
    gamePlayerController.gamePlayerData.docks.map((cardId, dockIndex) => {
        if (cardId === ANGRY_GHOST) {
            dockWeights[dockIndex] -= 10;
        } else if (cardId === null) {
            dockWeights[dockIndex] += 3;
        } else if (cardId === SATISFIED_GHOST) {
            dockWeights[dockIndex] += 2;
        } else {
            // will displace guest.
            dockWeights[dockIndex] += 1;
        }
    });
    let heaviest = Math.max(...dockWeights);
    let dockIndex = 3 - dockWeights.slice().reverse().indexOf(heaviest);
    let question = `Which Dock is best for a Ghost? `;
    let answer = dockIndex;
    let reason = 'From 3 to 0, Weight each dock, 3=Empty, 2=Ghosted, 1=Guest.'
    aiPackage.addProvenance(question, answer, reason);
    aiPackage.success = true;
    aiPackage.addToMessage(`Place Ghost in Dock ${dockIndex}`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.placeGhost(dockIndex);
    }
}
